import { useHistory } from 'react-router-dom';
import LibraryCardButton from '../LibraryCardButtons/LibraryCardButton';
import { fixedEncodeURIComponent, getLetterGradeFromNumberGrade } from '../../GlobalFunctions';
import styles from './LibraryCard.module.scss';
import { LibraryCardProps, LinkCardProps } from './cardData';
import { Icon } from '@iconify/react';
import eSStudent from '@iconify-icons/openmoji/family';
import lockAlt from '@iconify-icons/bx/lock-alt';

type Props = LibraryCardProps & LinkCardProps;

const LinkLibraryCard = ({
  isShow,
  displayName,
  subtitle,
  content,
  slug,
  buttonText,
  featuredImage,
  classroom,
  isWrongGrade,
  isLocked,
  isUpgradable,
}: Props): JSX.Element => {
  const history = useHistory();
  const isUnitLink = false;
  const handleClick = () => {
    if (isUpgradable) {
      history.push('/activatetrial');
      return;
    }
    if (isUnitLink) {
      history.push(
        `/${fixedEncodeURIComponent(classroom.className)}${slug}${getLetterGradeFromNumberGrade(classroom.grade)}`,
      );
      return;
    }
    window.open(slug, '_blank');
  };

  return (
    <>
      {isShow && (
        <div className={styles.container}>
          <div className={styles.imgContainer}>
            {isWrongGrade && !isLocked && (
              <div className={styles.wrongGrade}>
                <Icon icon={eSStudent} width={60} />
                Requires Elementary Classroom
              </div>
            )}
            {!isWrongGrade && !isLocked && (
              <img
                className={styles.linkLibraryCardThumbnail}
                src={featuredImage}
                alt={displayName}
                onClick={handleClick}
              />
            )}
            {isLocked && (
              <div className={styles.locked}>
                <Icon icon={lockAlt} width={60} />
                Requires Peekapak PRO Subscription
                <span className={styles.upgrade} onClick={() => history.push('/activatetrial')}>
                  Upgrade Now
                </span>
              </div>
            )}
          </div>
          <div className={styles.textContainer}>
            <h3 className={styles.typeHeading}>{subtitle && subtitle}</h3>
            <h2 className={styles.unitTitle}>{displayName && displayName}</h2>
            <p>{content}</p>
            <div className={styles.buttonRow}>
              {isWrongGrade && !isLocked && (
                <p>Please switch to an elementary school class using the menu bar to access this content</p>
              )}
              {!isWrongGrade && !isLocked && <LibraryCardButton buttonText={buttonText} handleClick={handleClick} />}
              {isUpgradable && isLocked && <LibraryCardButton buttonText={buttonText} handleClick={handleClick} />}
            </div>
            {isLocked && <div className={styles.lockFill} />}
          </div>
        </div>
      )}
    </>
  );
};

export default LinkLibraryCard;
